var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"ex-upload",attrs:{"action":'/dpt-web' + _vm.urlAction,"name":"importExcel","show-file-list":false,"limit":_vm.limit,"data":_vm.exData,"on-error":_vm.handleError,"on-success":_vm.handleSucces,"before-upload":_vm.handleBefore,"accept":".xlsx,.xls"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("导入")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }